/**
 * `?assistant=1` on `/create-task` is set by "Jump right in" and "Add new
 * task". The wizard shows the Spark assistant on every real entry whether or
 * not the param is present; the guided demo tour never shows it.
 */
export const WIZARD_ASSISTANT_QUERY_PARAM = 'assistant';
export const WIZARD_ASSISTANT_QUERY_VALUE = '1';

/**
 * Older sessions stored this when the panel was closed. The wizard no longer
 * reads or writes it: closing only hides the panel until the question-mark
 * button on that visit, and the next visit opens the panel again.
 */
export const WIZARD_ASSISTANT_DISMISSED_PREF = 'wizard_assistant_dismissed';

/** Accessible name of the button that brings the closed panel back. */
export const REOPEN_ASSISTANT_LABEL = 'Open assistant';

export const isWizardAssistantSearch = (searchParams) =>
    searchParams?.get?.(WIZARD_ASSISTANT_QUERY_PARAM) === WIZARD_ASSISTANT_QUERY_VALUE;
